<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body>
      <b-row>
      <b-col>

          <b-form-group label="Errors" v-if="showDismissibleAlert">
              <b-alert variant="danger" :show="showDismissibleAlert"  @dismissed="showDismissibleAlert=false" dismissible fade>
              <span v-for="items in submissionError">
                <ul v-for="item in items">
                  <li> {{item}} </li>
                </ul>
             </span>
            </b-alert>
         </b-form-group>
      </b-col>
      </b-row>
       <b-row>
         <b-col>
            <h1 variant="primary">Please Scan Ticket</h1>
         </b-col>
       </b-row>
       <b-row>
        <b-col>
        <b-form-group label="" label-for="idNumber">
          <b-form-input id="idNumber" :state="validateState('idNumber')" name="idNumber" v-on:keyup.enter="processScannedCard"   aria-describedby="liveFeedbackIdNumber"  v-model.lazy.trim="$v.form.idNumber.$model" autofocus />
          <b-form-invalid-feedback id="liveFeedbackIdNumber">
             This is a required field.
           </b-form-invalid-feedback>
        </b-form-group>
        </b-col>
       </b-row>  
    </b-card-body>
  </b-card>

</div>

</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

const formShape = {
  idNumber: null
}
export default {
  name: 'GateExitStatus',
  mixins: [validationMixin],

  components: {},
  data: function() {
    return {
      form: Object.assign({}, formShape),    
      submitted: false,    
      showDismissibleAlert: false,
      submissionError: "",

      showPrintButton : false
    }
  },
  validations: {
    form: {
      idNumber: {
        required
        }
    }
  },
  computed: {
    isValid() {
      this.$v.$touch();
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    processScannedCard(){
      this.submitted = true
      this.showDismissibleAlert=false;
      this.submissionError = "";
      console.log(JSON.stringify(this.form, null, 4));
      if(this.isValid){
        this.$nextTick(() => {
          let params = JSON.stringify(this.form);
          this.$store.dispatch('gate/updateVisitStatus', params)
            .then((response) => {
                if(response.data.success == false){
                  this.showErrorMsg({
                    message: response.data.error
                  });
                }
                else{
                  this.showSuccessMsg({
                    message: 'Record updated successfully.'
                  })
                 
                    this.onReset();
                  
                }


            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              }
              else if (error.response.status == 422){
                  this.showErrorMsg({
                    message: error.response.data.message
                  });              

              }
              else {
                this.showErrorMsg()
              }
              this.submitted = false

            })


        });
      }

    },
    onReset() {
      // Reset validation
      this.form.idNumber = "";
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.showDismissibleAlert = false;
      this.submissionError = "";
    
    },

 
  },
  created () {
    this.form.idNumber = "";
   

  },
  destroyed () {}

}

</script>
